import { render, staticRenderFns } from "./ReportePasajerosProcedencia.vue?vue&type=template&id=82e9a53a&scoped=true"
import script from "./ReportePasajerosProcedencia.vue?vue&type=script&lang=js"
export * from "./ReportePasajerosProcedencia.vue?vue&type=script&lang=js"
import style0 from "./ReportePasajerosProcedencia.vue?vue&type=style&index=0&id=82e9a53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e9a53a",
  null
  
)

export default component.exports